<template>
    <div class="uk-flex uk-flex-center">
        <div class="uk-width-4-5@m uk-width-2-3@l uk-article uk-card uk-card-body uk-card-default mbk_border_top_primary_5px mbk_large_box_shadow">
            <h4 :class="[sms_confirm.code === 1 ? 'uk-text-danger':'']">{{sms_confirm.text}}</h4>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    export default {
        name: "SmsStatus",
        computed: {
            ...mapGetters(["sms_confirm"])
        }
    }
</script>

<style scoped>

</style>